import { render, staticRenderFns } from "./Breadcrumbs.vue?vue&type=template&id=9a20a5fa"
import script from "./Breadcrumbs.vue?vue&type=script&lang=js"
export * from "./Breadcrumbs.vue?vue&type=script&lang=js"
import style0 from "./Breadcrumbs.vue?vue&type=style&index=0&id=9a20a5fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports